import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useNavigate} from "react-router-dom";
import {RefreshSharp} from "@mui/icons-material";
import {dataManager} from "../../Broadtask";
import AccountContactCard from "./AccountContactCard";
import {buttonStyle, cardWrapper, sectionPanel} from "../../../AppStyles";

const AccountContactsPane = (props) => {

    const navigate = useNavigate();
    const [contacts, setContacts] = useState(null);

    useEffect(() => {
        reload(false);
    }, []);

    function onRefresh()
    {
        reload(true);
    }

    function reload(force)
    {
        dataManager.getAccountManager().getContacts(force, (contacts) => {
            setContacts(contacts);
        });
    }

    function onAddContact()
    {
        navigate("../account/contacts/create");
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={sectionPanel}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/contact.png" width={32} height={32}/>
                    <Typography variant="h6">Contacts</Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Button onClick={onRefresh} sx={buttonStyle} startIcon={<RefreshSharp />} />
                    <Button onClick={onAddContact} sx={buttonStyle} startIcon={<AddCircleOutlineIcon />}>Add</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" spacing={1} padding={1} width="100%" minHeight={100}
                   useFlexGap sx={cardWrapper}>
                {
                    contacts === null ?
                        <Typography variant="h6">Loading...</Typography>:
                        contacts.map(nextContact => {
                            return (<AccountContactCard key={"contact_" + nextContact.contactUID} entry={nextContact} />)
                        })
                }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
);
}

export default AccountContactsPane;
